/**
 * Register the Hercules service worker and reload once when a new worker takes control.
 */
export function registerHerculesServiceWorker() {
    if (!('serviceWorker' in navigator)) {
        return;
    }

    var RELOAD_FLAG = 'hercules_sw_reloaded';

    // Clear prior reload marker so the next SW update can refresh again.
    try {
        if (sessionStorage.getItem(RELOAD_FLAG) === '1') {
            sessionStorage.removeItem(RELOAD_FLAG);
        }
    } catch (e) { /* private mode */ }

    navigator.serviceWorker
        .register('/service-worker.js', { scope: '/' })
        .then(function (registration) {
            console.log('[PWA] Service worker registered', registration.scope);
            registration.addEventListener('updatefound', function () {
                var installing = registration.installing;
                if (!installing) {
                    return;
                }
                installing.addEventListener('statechange', function () {
                    if (installing.state === 'installed' && navigator.serviceWorker.controller) {
                        console.log('[PWA] Updated service worker installed');
                    }
                });
            });
        })
        .catch(function (error) {
            console.error('[PWA] Service worker registration failed', error);
        });

    navigator.serviceWorker.addEventListener('controllerchange', function () {
        try {
            if (sessionStorage.getItem(RELOAD_FLAG) === '1') {
                return;
            }
            sessionStorage.setItem(RELOAD_FLAG, '1');
        } catch (e) {
            /* private mode */
        }
        window.location.reload();
    });
}
